import { Box, Grid, Skeleton } from '@factorialco/deprecated-design-system'

const InputSkeleton = () => (
  <Box gap="s8">
    <Skeleton height="s16" width="s120" />
    <Skeleton height="s40" width="full" />
  </Box>
)

const TwoColumnRow = () => (
  <Grid variant="fixed">
    <Box gridColSpan={{ xxs: 1, xs: 6 }}>
      <InputSkeleton />
    </Box>
    <Box gridColSpan={{ xxs: 1, xs: 6 }}>
      <InputSkeleton />
    </Box>
  </Grid>
)

export const VacancyCreationSkeleton = () => (
  <Box width="full" gap="s16">
    <InputSkeleton />
    <InputSkeleton />
    {Array.from({ length: 8 }).map((_, idx) => (
      <TwoColumnRow key={idx} />
    ))}
  </Box>
)
